import "core-js/modules/es.array.push.js";
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, unref as _unref, normalizeStyle as _normalizeStyle } from "vue";
const _hoisted_1 = {
  class: "page-apps custom-scroll"
};
const _hoisted_2 = {
  class: "flex h-20"
};
const _hoisted_3 = {
  class: "scrollbar-type-nav"
};
const _hoisted_4 = ["onClick"];
const _hoisted_5 = {
  key: 0,
  class: "image"
};
const _hoisted_6 = {
  class: "item"
};
const _hoisted_7 = {
  class: "image"
};
const _hoisted_8 = {
  class: "inner"
};
const _hoisted_9 = {
  class: "info"
};
const _hoisted_10 = {
  class: "info-title"
};
const _hoisted_11 = {
  class: "info-text"
};
const _hoisted_12 = {
  class: "btn"
};
const _hoisted_13 = {
  key: 1,
  style: {
    "width": "100%"
  }
};
import nodata from "@/assets/img/no-data.png";
import { onMounted, ref } from "vue";
import { ElMessage } from "element-plus";
import { httpGet, httpPost } from "@/utils/http";
import { checkSession } from "@/store/cache";
import { arrayContains, removeArrayItem, substr } from "@/utils/libs";
import { useRouter } from "vue-router";
import { useSharedStore } from "@/store/sharedata";
import ItemList from "@/components/ItemList.vue";
export default {
  __name: 'index',
  setup(__props) {
    const listBoxHeight = window.innerHeight - 133;
    const typeId = ref("");
    const appTypes = ref([]);
    const list = ref([]);
    const roles = ref([]);
    const store = useSharedStore();
    onMounted(() => {
      getAppType();
      getAppList();
      getRoles();
    });
    const getRoles = () => {
      checkSession().then(user => {
        roles.value = user.chat_roles;
      }).catch(e => {
        console.log(e.message);
      });
    };
    const getAppType = () => {
      httpGet("/app/type/list").then(res => {
        appTypes.value = res.data;
      }).catch(e => {
        ElMessage.error("获取分类失败：" + e.message);
      });
    };
    const getAppList = (tid = "") => {
      typeId.value = tid;
      httpGet("/app/list", {
        tid
      }).then(res => {
        const items = res.data;
        // 处理 hello message
        for (let i = 0; i < items.length; i++) {
          items[i].intro = substr(items[i].hello_msg, 80);
        }
        list.value = items;
      }).catch(e => {
        ElMessage.error("获取应用失败：" + e.message);
      });
    };
    const updateRole = (row, opt) => {
      checkSession().then(() => {
        const title = ref("");
        if (opt === "add") {
          title.value = "添加应用";
          const exists = arrayContains(roles.value, row.key);
          if (exists) {
            return;
          }
          roles.value.push(row.key);
        } else {
          title.value = "移除应用";
          const exists = arrayContains(roles.value, row.key);
          if (!exists) {
            return;
          }
          roles.value = removeArrayItem(roles.value, row.key);
        }
        httpPost("/app/update", {
          keys: roles.value
        }).then(() => {
          ElMessage.success({
            message: title.value + "成功！",
            duration: 1000
          });
        }).catch(e => {
          ElMessage.error(title.value + "失败：" + e.message);
        });
      }).catch(() => {
        store.setShowLoginDialog(true);
      });
    };
    const hasRole = roleKey => {
      return arrayContains(roles.value, roleKey, (v1, v2) => v1 === v2);
    };
    const router = useRouter();
    const useRole = role => {
      router.push(`/chat?role_id=${role.id}`);
    };
    return (_ctx, _cache) => {
      const _component_el_image = _resolveComponent("el-image");
      const _component_el_button = _resolveComponent("el-button");
      const _component_el_tooltip = _resolveComponent("el-tooltip");
      const _component_el_empty = _resolveComponent("el-empty");
      return _openBlock(), _createElementBlock("div", null, [_createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("ul", _hoisted_3, [_createElementVNode("li", {
        class: _normalizeClass({
          active: typeId.value === ''
        }),
        onClick: _cache[0] || (_cache[0] = $event => getAppList(''))
      }, "全部分类", 2), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(appTypes.value, item => {
        return _openBlock(), _createElementBlock("li", {
          key: item.id,
          class: _normalizeClass({
            active: typeId.value === item.id
          }),
          onClick: $event => getAppList(item.id)
        }, [item.icon ? (_openBlock(), _createElementBlock("div", _hoisted_5, [_createVNode(_component_el_image, {
          src: item.icon,
          fit: "cover"
        }, null, 8, ["src"])])) : _createCommentVNode("", true), _createTextVNode(" " + _toDisplayString(item.name), 1)], 10, _hoisted_4);
      }), 128))])]), _createElementVNode("div", {
        class: "app-list-container",
        style: _normalizeStyle({
          height: listBoxHeight + 'px'
        })
      }, [list.value.length > 0 ? (_openBlock(), _createBlock(ItemList, {
        key: 0,
        items: list.value,
        gap: 15,
        width: 300
      }, {
        default: _withCtx(scope => [_createElementVNode("div", _hoisted_6, [_createElementVNode("div", _hoisted_7, [_createVNode(_component_el_image, {
          src: scope.item.icon,
          fit: "cover"
        }, null, 8, ["src"])]), _createElementVNode("div", _hoisted_8, [_createElementVNode("div", _hoisted_9, [_createElementVNode("div", _hoisted_10, _toDisplayString(scope.item.name), 1), _createElementVNode("div", _hoisted_11, _toDisplayString(scope.item.hello_msg), 1)]), _createElementVNode("div", _hoisted_12, [_createVNode(_component_el_button, {
          size: "small",
          class: "sm-btn-theme",
          onClick: $event => useRole(scope.item)
        }, {
          default: _withCtx(() => _cache[1] || (_cache[1] = [_createTextVNode("使用")])),
          _: 2
        }, 1032, ["onClick"]), hasRole(scope.item.key) ? (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 0,
          content: "从工作区移除",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            size: "small",
            type: "danger",
            onClick: $event => updateRole(scope.item, 'remove')
          }, {
            default: _withCtx(() => _cache[2] || (_cache[2] = [_createTextVNode("移除")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024)) : (_openBlock(), _createBlock(_component_el_tooltip, {
          key: 1,
          content: "添加到工作区",
          placement: "top"
        }, {
          default: _withCtx(() => [_createVNode(_component_el_button, {
            size: "small",
            style: {
              "--el-color-primary": "#009999"
            },
            onClick: $event => updateRole(scope.item, 'add')
          }, {
            default: _withCtx(() => _cache[3] || (_cache[3] = [_createTextVNode("添加")])),
            _: 2
          }, 1032, ["onClick"])]),
          _: 2
        }, 1024))])])])]),
        _: 1
      }, 8, ["items"])) : (_openBlock(), _createElementBlock("div", _hoisted_13, [_createVNode(_component_el_empty, {
        description: "暂无数据",
        image: _unref(nodata)
      }, null, 8, ["image"])]))], 4)])]);
    };
  }
};